/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Team_Manager_Ad_Plugin_ToggledInputs */

const en_team_manager_ad_plugin_toggled = /** @type {(inputs: Team_Manager_Ad_Plugin_ToggledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AD Plugin ${i?.status} for user successfully`)
};

const fr_team_manager_ad_plugin_toggled = /** @type {(inputs: Team_Manager_Ad_Plugin_ToggledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plug-in AD ${i?.status} pour l’utilisateur avec succès`)
};

const de_team_manager_ad_plugin_toggled = /** @type {(inputs: Team_Manager_Ad_Plugin_ToggledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AD-Plugin ${i?.status} für Benutzer erfolgreich`)
};

const it_team_manager_ad_plugin_toggled = /** @type {(inputs: Team_Manager_Ad_Plugin_ToggledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plugin AD ${i?.status} per l'utente eseguito correttamente`)
};

const ru_team_manager_ad_plugin_toggled = /** @type {(inputs: Team_Manager_Ad_Plugin_ToggledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Плагин рекламы ${i?.status} успешно установлен для пользователя.`)
};

const es_team_manager_ad_plugin_toggled = /** @type {(inputs: Team_Manager_Ad_Plugin_ToggledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El complemento AD ${i?.status} para el usuario se ejecutó correctamente`)
};

const zh_cn2_team_manager_ad_plugin_toggled = /** @type {(inputs: Team_Manager_Ad_Plugin_ToggledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`用户 ${i?.status} 的 AD 插件已成功安装`)
};

const ja_team_manager_ad_plugin_toggled = /** @type {(inputs: Team_Manager_Ad_Plugin_ToggledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ユーザーのADプラグイン${i?.status}が正常にインストールされました`)
};

const hi_team_manager_ad_plugin_toggled = /** @type {(inputs: Team_Manager_Ad_Plugin_ToggledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता के लिए AD प्लगइन ${i?.status} सफलतापूर्वक इंस्टॉल हो गया।`)
};

const pt_pt2_team_manager_ad_plugin_toggled = /** @type {(inputs: Team_Manager_Ad_Plugin_ToggledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plugin AD ${i?.status} para o usuário com sucesso`)
};

/**
* | output |
* | --- |
* | "AD Plugin {status} for user successfully" |
*
* @param {Team_Manager_Ad_Plugin_ToggledInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_ad_plugin_toggled = /** @type {((inputs: Team_Manager_Ad_Plugin_ToggledInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Ad_Plugin_ToggledInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_ad_plugin_toggled(inputs)
	if (locale === "de") return de_team_manager_ad_plugin_toggled(inputs)
	if (locale === "it") return it_team_manager_ad_plugin_toggled(inputs)
	if (locale === "ru") return ru_team_manager_ad_plugin_toggled(inputs)
	if (locale === "es") return es_team_manager_ad_plugin_toggled(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_ad_plugin_toggled(inputs)
	if (locale === "ja") return ja_team_manager_ad_plugin_toggled(inputs)
	if (locale === "hi") return hi_team_manager_ad_plugin_toggled(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_ad_plugin_toggled(inputs)
	return en_team_manager_ad_plugin_toggled(inputs)
});